import { render, staticRenderFns } from "./CreateTenderFooter.vue?vue&type=template&id=61ae614a"
import script from "./CreateTenderFooter.vue?vue&type=script&lang=js"
export * from "./CreateTenderFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports